import { Controller } from '@hotwired/stimulus'

// The `.sp-drop` photo picker: confirms a pick before the form is saved (thumb, file name, size), and
// says so when the file is over the model's limit instead of letting the save bounce.
export default class extends Controller {
  static targets = ['thumb', 'title', 'hint']
  static values = { maxBytes: Number }

  disconnect() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
  }

  picked(event) {
    const file = event.target.files && event.target.files[0]
    if (!file) return
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = URL.createObjectURL(file)
    // No thumb is printed for an attached file that has no variant (an SVG background).
    if (this.hasThumbTarget) {
      this.thumbTarget.src = this.objectUrl
      this.thumbTarget.hidden = false
    }
    this.element.classList.add('sp-drop--filled')
    this.titleTarget.textContent = file.name

    const tooBig = this.hasMaxBytesValue && file.size > this.maxBytesValue
    this.hintTarget.classList.toggle('text-danger', tooBig)
    this.hintTarget.textContent = tooBig
      ? `This file is over ${Math.round(this.maxBytesValue / 1048576)} MB and will not save. Pick a smaller one.`
      : `${(file.size / 1048576).toFixed(1)} MB, uploads when you save.`
  }
}
